import { shallowEqual as A } from "./contact-channels57.js";
import { useMemo as E, useRef as b } from "react";
import { useCallMe as I } from "./contact-channels4.js";
import { useChat as M } from "./contact-channels5.js";
import { useEmail as R } from "./contact-channels6.js";
import { usePhone as N } from "./contact-channels3.js";
const L = {
  email: !0,
  callMe: !0,
  chat: !0,
  phone: !0
}, u = (t, e) => {
  var l, i, n;
  const s = t(e), r = {
    isLoading: s.isLoading || s.isPending,
    isAvailable: !s.isError && !!((l = s.data) != null && l.isAvailable),
    reason: (n = (i = s.data) == null ? void 0 : i.availabilityInfo) == null ? void 0 : n.reason
  }, o = b(r);
  return o.current.isLoading === r.isLoading && o.current.isAvailable === r.isAvailable && o.current.reason === r.reason || (o.current = r), o.current;
}, H = (t) => {
  const e = E(() => t ? Object.keys(L).reduce(
    (a, c) => (a[c] = t.includes(c), a),
    {}
  ) : L, [t == null ? void 0 : t.join(",")]), s = u(N, e.phone), r = u(R, e.email), o = u(I, e.callMe), d = u(M, e.chat), l = { phone: s, email: r, callMe: o, chat: d }, i = () => {
    const a = {}, c = [];
    return Object.entries(l).filter(([m]) => e[m]).forEach(([m, v]) => {
      const C = m, g = {
        isAvailable: v.isAvailable,
        reason: v.reason
      };
      a[C] = g, g.isAvailable && c.push(C);
    }), {
      channelsObject: a,
      availableChannelNames: c
    };
  }, n = b(i()), f = b(!1), j = () => {
    for (const a of Object.keys(l))
      if (e[a] && l[a].isLoading)
        return !0;
    return !1;
  }, h = i();
  (!A(h.channelsObject, n.current.channelsObject) || !A(h.availableChannelNames, n.current.availableChannelNames)) && (n.current = h);
  const p = j();
  p !== f.current && (f.current = p);
  const y = n.current.channelsObject, O = n.current.availableChannelNames;
  return {
    isLoading: f.current,
    channelInfo: y,
    availableChannels: O
  };
};
export {
  H as useChannelsAvailability
};
//# sourceMappingURL=contact-channels8.js.map
